$(document).on('Searchanise.ResultsUpdated', () => {
    $(document).ready(() => {
        appendNoResultsMessage();
        updateCollectionTitle();
    });
});

$(document).ready(() => {
    initRedirect();
    initCustomerVehicleButton();
    

    const params = new URLSearchParams(window.location.search);
    if (params.has('open-widget')) {
        openOffcanvas();
    } else {
      initVehicleSelect();
    }
});


const metafield = {
    racing_planet: 'rb_filter_metafield_725ba553f080b9f1c1054e0d9eb224c1',
    parts_europe: 'rb_filter_metafield_ea1697340874ee35497e3137b1d05850',
};

let widgetLoaded = false;

const m21FinderLabels={"lv":{"finder":"Detaļu meklētājs","heading":"Atrodi detaļas savam motociklam","subtitle":"Izvēlies marku un modeli vai izmanto meklēšanu.","change":"Mainīt","cancel":"Atcelt","parts":"Piemērotās detaļas","close":"Aizvērt"},"lt":{"finder":"Dalių paieška","heading":"Rask dalis savo motociklui","subtitle":"Pasirink markę ir modelį arba naudokis paieška.","change":"Keisti","cancel":"Atšaukti","parts":"Tinkančios dalys","close":"Uždaryti"},"et":{"finder":"Varuosade otsing","heading":"Leia oma mootorrattale varuosad","subtitle":"Vali mark ja mudel või kasuta otsingut.","change":"Muuda","cancel":"Tühista","parts":"Sobivad varuosad","close":"Sulge"},"en":{"finder":"Parts finder","heading":"Find parts for your motorcycle","subtitle":"Choose a make and model or use the search.","change":"Change","cancel":"Clear selection","parts":"Compatible parts","close":"Close"}};
function m21FinderText(key){ const lang=getLocalePrefix().slice(1)||"lv"; return m21FinderLabels[lang][key]; }


function initRedirect() {
    if (!isCompatiblePartsPage()) return;

    if (window.location.href.includes(metafield.racing_planet) || window.location.href.includes(metafield.parts_europe)) return;

    const params = new URLSearchParams(window.location.search);
    if (params.has('open-widget')) return;

    const vehicle = getCustomerVehicleFromLocalStorage();

    if (!vehicle) return;

    location.href = getVehicleCollectionURL(vehicle);
}

function getVehicleCollectionURL(vehicle) {
    const locale = getLocalePrefix();
    const path = `${locale}/collections/compatible-parts`;
    return vehicle
        ? `${path}?${vehicle.vehicle_type === 'racing_planet' ? metafield.racing_planet : metafield.parts_europe}=${encodeURIComponent(vehicle.vehicle_id)}`
        : path;
}

function isCompatiblePartsPage() {
    return window.location.pathname.endsWith('/collections/compatible-parts');
}

function getLocalePrefix() {
    const match = window.location.pathname.match(/^\/(en|lt|et)(\/|$)/);
    return match ? `/${match[1]}` : '';
}


function initCustomerVehicleButton() {
    const vehicle = getCustomerVehicleFromLocalStorage();
    const make = String(vehicle?.bike_producer || '').trim();
    const model = [vehicle?.bike_model, vehicle?.sales_name].filter(Boolean).join(' ').trim();
    const year = String(vehicle?.year || '').trim();
    const fullName = [make, model, year].filter(Boolean).join(' ');
    document.querySelectorAll('.customer-vehicle').forEach(button => {
        button.href = vehicle ? getVehicleCollectionURL(vehicle) : getLocalePrefix() + '/collections/compatible-parts?open-widget=1';
        button.classList.toggle('has-vehicle', Boolean(vehicle));
        button.title = vehicle ? fullName : m21FinderText('finder');
        button.setAttribute('aria-label', vehicle ? m21FinderText('parts') + ': ' + fullName : m21FinderText('finder'));
        const label = button.querySelector('span');
        if (!label) return;
        label.classList.add('m21-vehicle-button-label');
        label.replaceChildren();
        if (!vehicle) { label.textContent = m21FinderText('finder'); return; }
        const brand = document.createElement('span');
        brand.className = 'm21-vehicle-make';
        brand.textContent = make;
        const details = document.createElement('span');
        details.className = 'm21-vehicle-details';
        const modelLabel = document.createElement('span');
        modelLabel.className = 'm21-vehicle-model';
        modelLabel.textContent = model;
        details.append(modelLabel);
        if (year) {
            const yearLabel = document.createElement('span');
            yearLabel.className = 'm21-vehicle-year';
            yearLabel.textContent = year;
            details.append(yearLabel);
        }
        label.append(brand, details);
    });
    const title = document.querySelector('.vehicle-offcanvas-title');
    const subtitle = document.querySelector('.vehicle-offcanvas-subtitle');
    if (title) { title.textContent = m21FinderText('heading'); title.id = 'm21-vehicle-heading'; }
    if (subtitle) subtitle.textContent = m21FinderText('subtitle');
    document.querySelector('#offcanvasCustomerVehicleSelect')?.setAttribute('aria-labelledby', 'm21-vehicle-heading');
    document.querySelector('.close-offcanvas-btn')?.setAttribute('aria-label', m21FinderText('close'));
}


function getCustomerVehicleFromLocalStorage() {
    try {
        const vehicle = JSON.parse(localStorage.getItem('selectedVehicle'));
        return vehicle && vehicle.vehicle_id != null && ['racing_planet', 'parts_europe'].includes(vehicle.vehicle_type) ? vehicle : null;
    } catch (_) { return null; }
}

function createButton(text, onClick) {
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = text;
    button.classList.add('vehicle-action-bar-btn');
    button.onclick = onClick;
    return button;
}

function handleChangeVehicle() {
    const offcanvas = new bootstrap.Offcanvas(document.getElementById('offcanvasCustomerVehicleSelect'));
    offcanvas.show();
}

function handleCancelVehicle() {
    localStorage.removeItem('selectedVehicle');
    window.location.href = `${getLocalePrefix()}/collections/all`;
}

function updateCollectionTitle() {
    if (!isCompatiblePartsPage()) return;

    const vehicleData = getCustomerVehicleFromLocalStorage();
    const titleElement = document.querySelector('.snize-main-panel-collection-results-found');
    const existingActionBarElement = document.querySelector('.vehicle-action-bar');

    if (!vehicleData || !titleElement || existingActionBarElement) return;
    titleElement.classList.add('m21-vehicle-results-title');

    // Remove existing subtitle if present
    document.querySelector('.vehicle-action-bar')?.remove();

    // Create subtitle container
    const subtitleElement = document.createElement('div');
    subtitleElement.classList.add('vehicle-action-bar');

    // Create vehicle title span
    const vehicleTitle = document.createElement('span');
    vehicleTitle.classList.add('vehicle-bar-title');
    vehicleTitle.textContent = `${vehicleData.bike_producer} ${vehicleData.bike_model} ${vehicleData.sales_name ?? ''} ${vehicleData.year ?? ''}`.trim();

    // Create button container
    const buttonContainer = document.createElement('span');
    buttonContainer.classList.add('vehicle-action-bar-btn-container');
    buttonContainer.append(createButton(m21FinderText('change'), handleChangeVehicle), createButton(m21FinderText('cancel'), handleCancelVehicle));

    // Append elements
    subtitleElement.append(vehicleTitle, buttonContainer);
    titleElement.appendChild(subtitleElement);
}


function appendNoResultsMessage() {
    if (!isCompatiblePartsPage()) return;
    if (!isSingleSearchParam()) return;

    const noProductsCustomElement = document.querySelector('.snize-custom-no-results');
    if (noProductsCustomElement) return;

    const noProductsElement = document.querySelector('.snize-no-products-found');
    if (!noProductsElement) return;

    const resultsContainer = document.querySelector('#snize_results .snize-horizontal-wrapper .snize-horizontal-left');
    const mainContent = document.querySelector('.snize-main-panel');
    if (!resultsContainer && !mainContent) return;

    const newWrapper = document.createElement('div');
    newWrapper.classList.add('snize-custom-no-results');
    newWrapper.innerHTML = `
    <div class="snize-main-panel-collection-results-found" aria-live="polite">
        ${m21FinderText('parts')}
    </div>
  `;



    if (window.innerWidth < 992) {
        if (mainContent) {
            mainContent.parentNode.insertBefore(newWrapper, mainContent);
        }
    } else {
        resultsContainer.appendChild(newWrapper);
    }
}


function isSingleSearchParam() {
    const params = new URLSearchParams(window.location.search);
    const allowedKeys = [
        "rb_filter_metafield_725ba553f080b9f1c1054e0d9eb224c1",
        "rb_filter_metafield_ea1697340874ee35497e3137b1d05850"
    ];
    const paramKeys = Array.from(params.keys());
    return paramKeys.length === 1 && allowedKeys.includes(paramKeys[0]);
}

const initVehicleSelect = function () {
    if (!isCompatiblePartsPage()) return;

    const vehicleData = getCustomerVehicleFromLocalStorage();
    if (!vehicleData) {
        openOffcanvas();
    }
};

function vehicleSelectCallback(vehicle) {
    location.href = getVehicleCollectionURL(vehicle);
}

function openOffcanvas() {
    const offcanvasElement = document.getElementById('offcanvasCustomerVehicleSelect');
    const closeButton = offcanvasElement.querySelector('.close-offcanvas-btn');

    // Check if a vehicle is stored in localStorage
    const vehicle = getCustomerVehicleFromLocalStorage();

    if (!vehicle) {
        offcanvasElement.setAttribute('data-bs-backdrop', 'static'); // Make static
        if (closeButton) closeButton.style.display = 'none'; // Hide close button
    } else {
        offcanvasElement.removeAttribute('data-bs-backdrop'); // Allow dismissal
        if (closeButton) closeButton.style.display = 'block'; // Show close button
    }

    new bootstrap.Offcanvas(offcanvasElement).show();
}

$('#offcanvasCustomerVehicleSelect').on('show.bs.offcanvas', function () {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    if (!widgetLoaded) {
        widgetLoaded = true;

        // Get "tab" from URL
        const params = new URLSearchParams(window.location.search);
        const tab = params.get('tab');
        const validTabs = ['1', '2'];

        // Pass tab as 3rd param if valid
        const defaultTab = validTabs.includes(tab) ? (tab === '1' ? 'parts_europe' : 'racing_planet') : undefined;

        window.vehicleWidget('#customerVehicleSelect', vehicleSelectCallback, defaultTab);
    }
});


$('#offcanvasCustomerVehicleSelect').on('hidden.bs.offcanvas', () => {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
});
